// Human-readable labels for the column-type enum. The stored enum keeps
// `text` as the long variant for backwards compatibility, so the UI relabels
// it to "Long text" and pairs it with "Short text" for the capped single-line
// type. Unmapped types fall back to a title-cased form of the enum value.
const TYPE_LABELS = {
  short_text: "Short text",
  text: "Long text",
  number: "Number",
  date: "Date",
  boolean: "Boolean",
  single_select: "Single-select",
  multi_select: "Multi-select",
  list: "List",
  relationship: "Relationship",
  email: "Email",
  url: "URL",
  phone: "Phone",
  percentage: "Percentage",
  currency: "Currency",
};

export const typeLabel = type =>
  TYPE_LABELS[type] ??
  String(type ?? "")
    .replace(/_/g, " ")
    .replace(/^\w/, c => c.toUpperCase());

export default typeLabel;
